import styled from 'styled-components';
import { device } from '../../styles/devices';
import type { ThemeProps } from '../../types';

export const TextLink = styled.a`
  svg {
    margin-right: 8px;
  }
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  font-family: 'Audi Type';
  text-underline-offset: 6.5px;
  line-height: 20px;
  font-size: 12px;
  text-decoration: underline 1px rgb(0, 0, 0);
  letter-spacing: 0px;
  font-weight: 400;
  padding: 0;
  padding-bottom: 6px;
  color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
`;

export const CarfaxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
  @media ${device.tablet} {
    margin-top: unset;
  }
`;

export const CarfaxIconWrapper = styled.div`
  height: 29px;
  svg {
    height: inherit;
    width: auto;
  }
`;
